export class CmsFooterContactsProperties {
  sr: number = 0;
  type: string = "";
  details: string = "";
}
export class CmsFooterSitemapProperties {
  sr: number = 0;
  name: string = "";
  pageLink: string = "";
}
export class CmsFooterSocialProperties {
  sr: number = 0;
  icons: string = "";
  socialLinks: string = "";
  iconsName: string = "";
}
export class PrivacyPolicyProperties {
  privacyID: number = 0;
  privacyStatement: string = "";
  status: boolean;
}
export class TermsOfUseProperties {
  termID: number = 0;
  termAndConditions: string = "";
  generalDisclaimer: string = "";
  bookingTerms: string = "";
  promotionTerms: string = "";
  paymentTerms: string = "";
  cancellationAndRefund: string = "";
  addresses: string = "";
}
